"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormGroup = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var clsx_1 = __importDefault(require("clsx"));
var O = __importStar(require("fp-ts/Option"));
var function_1 = require("fp-ts/function");
var React = __importStar(require("react"));
var propsFilter_1 = require("../../library/propsFilter");
var SharkMorphContext_1 = require("../../providers/SharkMorphContext");
require("./formGroup.css");
var Prefix = function (props) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "form-group-prefix" }, { children: (0, jsx_runtime_1.jsx)("div", { children: props.children }) }))); };
var Content = function (props) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('form-group-content', { fillAllWidth: props.fillAllWidth }, { fullWidth: props.fullWidth }) }, { children: (0, jsx_runtime_1.jsx)("div", { children: props.children }) }))); };
var Suffix = function (props) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "form-group-suffix" }, { children: (0, jsx_runtime_1.jsx)("div", { children: props.children }) }))); };
var Errors = function (props) { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "form-group-error" }, { children: (0, jsx_runtime_1.jsx)("div", { children: props.children }) }))); };
var FormGroup = /** @class */ (function (_super) {
    __extends(FormGroup, _super);
    function FormGroup(props) {
        var _this = _super.call(this, props) || this;
        _this.settedTimeout = null;
        _this.state = {
            canShowValidatoResult: !props.waitToShowNegativeValidation || (0, function_1.pipe)(O.fromNullable(props.validationResult), O.isSome),
            waitToShow: false,
        };
        return _this;
    }
    FormGroup.prototype.getFormTheme = function () {
        if (!this.props.validationResult) {
            return null;
        }
        if (!this.state.canShowValidatoResult && this.props.validationResult.type !== 'success') {
            return null;
        }
        return "form-theme-".concat(this.props.validationResult.type);
    };
    FormGroup.prototype.renderLabel = function () {
        if (this.props.label) {
            return (0, jsx_runtime_1.jsx)("label", { children: this.props.label });
        }
        return null;
    };
    FormGroup.prototype.componentDidUpdate = function () {
        var _this = this;
        this.setState(function (prevState) { return ({
            canShowValidatoResult: !prevState.waitToShow ||
                (0, function_1.pipe)(O.fromNullable(_this.props.validationResult), O.filter(function (vr) { return vr.type === 'success'; }), O.isSome),
        }); });
    };
    FormGroup.prototype.componentWillUnmount = function () {
        if (this.settedTimeout) {
            clearInterval(this.settedTimeout);
        }
    };
    FormGroup.prototype.renderErrorOrWarning = function () {
        if (!this.state.canShowValidatoResult ||
            !this.props.validationResult ||
            this.props.validationResult.type === 'success') {
            return null;
        }
        return ((0, jsx_runtime_1.jsx)(FormGroup.Errors, { children: this.props.validationResult.messages.map(function (error, index) {
                return (0, function_1.pipe)(O.fromNullable(error), O.map(function (e) { return ((0, jsx_runtime_1.jsx)("div", { dangerouslySetInnerHTML: {
                        __html: e.replace(/\n/g, '<br />'),
                    } }, index)); }), O.toNullable);
            }) }));
    };
    FormGroup.prototype.hasSuffix = function () {
        if (!this.props.children) {
            return false;
        }
        if (Array.isArray(this.props.children)) {
            return this.props.children.filter(function (e) { return e && e.type === Suffix; }).length !== 0;
        }
        return this.props.children.type === Suffix;
    };
    FormGroup.prototype.render = function () {
        var _this = this;
        return ((0, jsx_runtime_1.jsxs)("div", __assign({}, (0, propsFilter_1.getAllDataProps)(this.props, this.context), { className: (0, clsx_1.default)('form-group', this.getFormTheme()) }, { children: [this.renderLabel(), (0, jsx_runtime_1.jsx)("div", __assign({ className: (0, clsx_1.default)('form-group-body', { 'with-suffix': this.hasSuffix() }, { flex: this.props.flex ? true : false }), onPaste: function () { return _this.setState({ waitToShow: false }); }, onBlur: function () { return _this.setState({ waitToShow: false }); }, onFocus: function () {
                        var waitToShowNegativeValidation = _this.props.waitToShowNegativeValidation;
                        if (!waitToShowNegativeValidation.type) {
                            return;
                        }
                        if (_this.settedTimeout) {
                            clearTimeout(_this.settedTimeout);
                        }
                        _this.setState({
                            waitToShow: (0, function_1.pipe)(O.fromNullable(_this.props.validationResult), O.filter(function (vr) { return vr.type === 'error' || vr.type === 'warning'; }), O.isNone),
                        }, function () {
                            _this.settedTimeout = setTimeout(function () {
                                _this.setState({ waitToShow: false });
                            }, waitToShowNegativeValidation.wait);
                        });
                    } }, { children: this.props.children })), this.renderErrorOrWarning()] })));
    };
    FormGroup.Prefix = Prefix;
    FormGroup.Content = Content;
    FormGroup.Suffix = Suffix;
    FormGroup.Errors = Errors;
    FormGroup.contextType = SharkMorphContext_1.SharkMorphContext;
    return FormGroup;
}(React.PureComponent));
exports.FormGroup = FormGroup;
FormGroup.defaultProps = {
    inline: false,
};
//# sourceMappingURL=FormGroup.js.map